import { SortableHandle } from 'react-sortable-hoc';
import React from 'react';
import { MenuOutlined } from '@ant-design/icons/lib';

const HandleIcon: React.FC = () => (
  <span
    className="asset-dnd-handle"
    onClick={(e) => e.stopPropagation()}
  >
    <MenuOutlined className="cursor-pointer" />
  </span>
);

export const DragHandle = SortableHandle(() => <HandleIcon />);
